export type Entity = {
  id: string;
  name: string;
};

export const createEntity = (data: Entity): Entity => ({
  id: data.id,
  name: data.name,
});
